import { useContext } from "react";
import { ApiContext } from "../../contexts/ApiContext";
import { useMutation } from "react-query";
import { QueryCallbacks } from "../../shared/interfaces/ReactQuery";

export function useHvSubstationDelete(callbacks?: QueryCallbacks<null>) {
  const apiContext = useContext(ApiContext);

  return useMutation({
    mutationKey: ["deleteHvSubstation"],
    mutationFn: (hvSubstationId: number) => apiContext.hvSubstationApis.deleteHvSubstation(hvSubstationId),
    onSuccess: callbacks?.onSuccess,
    onError: callbacks?.onError,
  });
}
